.overlay {
  position: fixed;
  inset: 0;
  z-index: 400;
  background: var(--scrim);
  border: none;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 401;
  width: 520px;
  max-width: 95vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  background: var(--card-bg);
  border-radius: var(--r-lg);
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.2);
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.title {
  font-size: 16px;
  font-weight: 700;
}
.spacer {
  flex: 1;
}

.close {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  color: var(--text2);
  cursor: pointer;
}

.close:hover {
  color: var(--text);
}

.body {
  flex: 1;
  overflow-y: auto;
  padding: 18px 20px;
}

.section {
  margin-bottom: 22px;
}

.sectionTitle {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 10px;
}

.profile {
  display: flex;
  align-items: center;
  gap: 14px;
}

.avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--blue);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  font-weight: 700;
  flex-shrink: 0;
  object-fit: cover;
}

.profileName {
  font-size: 15px;
  font-weight: 600;
}
.profileMeta {
  font-size: 13px;
  color: var(--text2);
  margin-top: 2px;
}

.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.label {
  font-size: 13px;
  color: var(--text2);
  margin-bottom: 4px;
}

.input {
  padding: 8px 11px;
  font-size: 13px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--input-bg);
  color: var(--text);
}

.row {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.button {
  padding: 7px 13px;
  font-size: 12.5px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--card-bg);
  color: var(--text2);
  cursor: pointer;
}

.button:hover {
  border-color: var(--blue);
  color: var(--blue);
}

.primary {
  background: var(--blue);
  border-color: var(--blue);
  color: #fff;
  font-weight: 600;
}
.primary:hover {
  background: var(--blue-dark);
  color: #fff;
}

.danger {
  color: var(--action-danger);
  background: var(--card-bg);
  border-color: color-mix(in srgb, var(--action-danger) 40%, transparent);
}
.danger:hover {
  color: #fff;
  background: var(--action-danger);
  border-color: var(--action-danger);
}
:global(html.dark) .danger {
  color: var(--err);
}
:global(html.dark) .danger:hover {
  color: #fff;
}

.themeRow {
  display: flex;
  gap: 6px;
}

.themeBtn {
  flex: 1;
  padding: 9px;
  font-size: 12.5px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--card-bg);
  color: var(--text2);
  cursor: pointer;
}

.themeBtnActive {
  background: var(--blue-lt);
  border-color: var(--blue);
  color: var(--blue);
  font-weight: 600;
}

.status {
  font-size: 12.5px;
  color: var(--text2);
}
.statusOn {
  color: var(--ok);
  font-weight: 600;
}

.message {
  margin-top: 10px;
  padding: 8px 11px;
  font-size: 13px;
  border-radius: var(--r-sm);
}

.messageOk {
  color: var(--ok);
  background: var(--ok-bg);
}
.messageErr {
  color: var(--err);
  background: var(--err-bg);
}

.qrWrap {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

@media (max-width: 640px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    top: 0;
    left: 0;
    transform: none;
  }
}
